var blockquote_default = {
  "fontElementMap": "fJY-T",
  "quote": "pA9F5"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
